import React, { FC, memo, useCallback } from 'react'
import { Slide } from 'pure-react-carousel'

import ListingSectionTransport from '../../../transports/common/listing-section-transport'
import GridCard from '../../region-landing-page/common/grid-card'
import {
    CtaButtonText,
    CtaContainer,
    Section,
    StyledGhostButton,
    Subtitle,
    Title,
    TitleContainer,
} from '../common/styles'
import { useTranslation } from '../../../hooks/locale'
import { BreadcrumbListTransport } from '../../../models/common/breadcrumb-model'
import PrevNextControls from '../../common/prev-next-controls'
import { useResponsiveCards } from '../../../hooks/responsive'
import { SliderContainer, StyledCarouselProvider, StyledSlider } from '../../common/listing-card-section/styles'

interface Props {
    listingSection: ListingSectionTransport
    url: string
    breadcrumbList?: BreadcrumbListTransport
    sitePathname?: string
    defaultHeading: string
    defaultSubheading?: string
}

const TopOffersSection: FC<Props> = ({
    listingSection,
    url,
    breadcrumbList,
    sitePathname,
    defaultHeading,
    defaultSubheading,
}) => {
    const { t } = useTranslation()

    const { objects, cta } = listingSection

    const heading = listingSection.heading || defaultHeading
    const subheading = listingSection.subheading || defaultSubheading

    const visibleSlides = useResponsiveCards()
    const dragStep = Math.floor(visibleSlides)

    const _handleCTAButtonClick = useCallback(() => {
        document.location.href = cta?.url || url
    }, [url, cta?.url])

    return (
        <Section id="top-offers">
            <TitleContainer>
                <Title>{heading}</Title>
                {!!subheading && <Subtitle>{subheading}</Subtitle>}
            </TitleContainer>
            <SliderContainer>
                <StyledCarouselProvider
                    totalSlides={objects.length}
                    visibleSlides={visibleSlides}
                    naturalSlideWidth={1}
                    naturalSlideHeight={1}
                    isIntrinsicHeight
                    lockOnWindowScroll
                    dragStep={dragStep}
                    step={dragStep}
                >
                    <PrevNextControls totalObjects={objects.length} visibleSlides={visibleSlides} />
                    <StyledSlider $transitionTime={0.2}>
                        {objects.map((object, index) => (
                            <Slide index={index} key={object.id}>
                                <GridCard
                                    key={object.id}
                                    listingObject={object}
                                    breadcrumbList={breadcrumbList}
                                    position={index}
                                    requestUrl={url}
                                    sitePathname={sitePathname}
                                />
                            </Slide>
                        ))}
                    </StyledSlider>
                </StyledCarouselProvider>
            </SliderContainer>
            {!!cta?.url && (
                <CtaContainer>
                    <StyledGhostButton onClick={_handleCTAButtonClick} borderRadius="1rem">
                        <CtaButtonText>{t('seeAll')}</CtaButtonText>
                    </StyledGhostButton>
                </CtaContainer>
            )}
        </Section>
    )
}

export default memo(TopOffersSection)
